<template>
  <b-container fluid>
    <div class="horizontal-menu">
      <b-row>
        <b-col>
          <h2>Clones</h2>
        </b-col>
        <b-col class="float-right">
          <!-- Actions -->
        </b-col>
      </b-row>

      <b-nav>
        <b-nav-item :to="{name: 'voices'}" active-class="tab_active">Clones</b-nav-item>
      </b-nav>
    </div>

    <keep-alive include="voice_list">
      <router-view :profile="profile" :user="user"/>
    </keep-alive>
  </b-container>
</template>

<script>
export default {
  props: ['profile', 'user'],
  name: 'container',
}
</script>

<style>

</style>
